import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { stationMatches } from 'utils/search'
import { images, fallback } from 'images/image-library'
import { ImageAsset } from 'components/common/image-asset'
import { ReactComponent as ActiveIcon } from 'images/checkbox/active.svg'
import { ReactComponent as InactiveIcon } from 'images/checkbox/inactive.svg'
import styles from '../StationSelector.module.scss'

const cx = classNames.bind(styles)

const StationList = ({
  stations,
  value,
  search,
  handleDropdownItemClick
}) => {
  const filteredStations = search
    ? stations.filter((s) => stationMatches(s.name, search))
    : stations.slice()

  return (
    <>
      {filteredStations.map((station) => (
        <div
          key={station.id}
          className={cx('item')}
          onClick={(event) => handleDropdownItemClick(event, station.id)}
          data-testid="item"
        >
          <div className={cx('station-name')}>
            <ImageAsset
              height={20}
              width={20}
              src={images.brandImage(station.brand?.key)}
              alt={`station-cell-brand-${station.brand?.key}`}
              fallbackImage={fallback.defaultBrand}
            />
            <span>{station.name}</span>
          </div>
          {value.includes(station.id) ? <ActiveIcon /> : <InactiveIcon />}
        </div>
      ))}
    </>
  )
}

StationList.propTypes = {
  stations: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
  handleDropdownItemClick: PropTypes.func.isRequired
}

export default StationList
